import React, { useEffect } from "react";

import { Button } from "semantic-ui-react";

import { useSync } from "data/hub/sync";

import { useBooleanState } from "hooks";
import Tooltip from "components/Tooltip";

import {
  useImportedMeetingTypes,
  useUpdateImportedMeetingTypes,
} from "./hooks";
import { EditImportedSyncEntityModal } from "../EditImportedSyncEntityModal";
import { ImportedSyncEntityTable } from "../ImportedSyncEntityTable";

export function ImportedMeetingTypesTable() {
  const [isEditModalOpen, openEditModal, closeEditModal] = useBooleanState();

  const { syncInProgress, syncCompleted, runMeetingsSync } = useSync();
  const { data, loading, error, reloadData, isEmpty } =
    useImportedMeetingTypes();
  const { update, loading: updating } = useUpdateImportedMeetingTypes(() => {
    runMeetingsSync();
    closeEditModal();
  });

  useEffect(() => {
    if (syncCompleted) reloadData();
  }, [syncCompleted, reloadData]);

  if (error) {
    return <div style={{ fontStyle: "italic" }}>{error}</div>;
  }

  if (isEmpty && !loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          alignItems: "flex-start",
        }}
      >
        <span>
          You do not have any synced meeting types. Please click on the button
          below to sync your CRM meeting types to Hubly.
        </span>

        <Button primary onClick={runMeetingsSync} disabled={syncInProgress}>
          Sync Meeting Types
        </Button>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ImportedSyncEntityTable
        loading={loading}
        rows={data}
        columns={[
          { id: "meeting-types", title: "Meeting Types" },
          { id: "imported-meeting-dates", title: "Imported Meeting Dates" },
        ]}
      />

      {!loading && (
        <Tooltip
          title="You cannot edit Imported Meeting Types while a CRM sync is in progress"
          hidden={!syncInProgress}
        >
          <div style={{ display: "inline-block" }}>
            <Button primary disabled={syncInProgress} onClick={openEditModal}>
              Edit Imported Meeting Types
            </Button>
          </div>
        </Tooltip>
      )}

      {isEditModalOpen && (
        <EditImportedSyncEntityModal
          importedTypes={data}
          loading={updating}
          onClose={closeEditModal}
          onSubmit={update}
          title="Edit Imported Meeting Types"
          subtitle="Select meeting types to sync with Hubly"
          columnName="Meeting Types"
          type="inclusion"
        />
      )}
    </React.Fragment>
  );
}

export default ImportedMeetingTypesTable;
